import React from "react";
import { Reorder } from 'framer-motion';
import { matchPhrases } from "../../../utils/utilities";

import AccordionItem from "../custom-visual-inspection/accordion-item";
import CustomNewItem from '../custom-general/custom-new-item';
import ItemCount from '../../blocks/item-count';
import PMIResultForm, { PMIResult } from "../../forms/custom-pmi/pmiResultForm";
import ReorderItem from '../../common/reorderItem';

import toastService from "../../../services/toastService";

interface Props {
    elements: string[];
    pmiResultItems: PMIResult[];
    onChangePMIResultItems: (items: PMIResult[]) => void;
}

const PMIResultItems: React.FC<Props> = ({ elements, pmiResultItems, onChangePMIResultItems }) => {
    const handleAddItem = (item: PMIResult) => {
        const itemMatch = pmiResultItems.find((analysisItem) => matchPhrases(analysisItem.itemDescription, item.itemDescription));
        if (itemMatch) return toastService.error(`CDR Number ${item.itemDescription} already exists!`);

        const newAnalysisItems = [...pmiResultItems, item];
        onChangePMIResultItems(newAnalysisItems);
    };

    const handleDeleteItem = (item: PMIResult) => {
        const newAnalysisItems = pmiResultItems.filter((analysis) => analysis.itemDescription !== item.itemDescription);
        onChangePMIResultItems(newAnalysisItems);
    };
   
    const handleEditItem = (baseItem: PMIResult, updatedItem: PMIResult) => {
        const newAnalysisItems = pmiResultItems.map((analysis) => analysis.itemDescription === baseItem.itemDescription ? updatedItem : analysis);
        onChangePMIResultItems(newAnalysisItems);
    };

    return ( 
        <>
            <ItemCount count={pmiResultItems.length} label='PMI Result Items' />
                            
            <CustomNewItem label='Add New PMI Result'>
                <PMIResultForm elements={elements} onSave={handleAddItem} />
            </CustomNewItem>
            
            <Reorder.Group className="list-unstyled" values={pmiResultItems} onReorder={onChangePMIResultItems}>
                {pmiResultItems.map((item) => (
                    <ReorderItem key={item.itemDescription} value={item}>
                        <AccordionItem title={item.itemDescription} isActive>
                            <PMIResultForm
                                elements={elements}
                                initialPMIData={item}
                                onSave={(updated: PMIResult) => handleEditItem(item, updated)}
                                onDeleteItem={() => handleDeleteItem(item)}
                            />
                        </AccordionItem>
                    </ReorderItem>
                ))}
            </Reorder.Group>
        </>
     );
};
 
export default PMIResultItems;